var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.showAppToolbar)?_c('app-toolbar'):_vm._e(),(_vm.showAppDrawer)?_c('app-drawer'):_vm._e(),_c('v-main',[_c('v-container',{staticClass:"pa-0",attrs:{"fluid":"","fill-height":""}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }